import { BatchPlan } from "@components/Sales/batch.type";
import { SUPER_MODAL_ENUM } from "@utils/enum";
import { atom } from "jotai";

export type modalPropsType = {
    panelClassName?: string;
    backdropClick?: boolean;
};

interface superModalAtom {
    type: SUPER_MODAL_ENUM;
    isOpen: boolean;
    props?: any;
    modalProps?: modalPropsType;
    isAnimate?: boolean;
}
export const superModalAtom = atom<superModalAtom>({
    type: SUPER_MODAL_ENUM.NONE,
    props: undefined,
    isOpen: false,
    modalProps: undefined,
    isAnimate: false,
});
export class UserData {
    batchUserSegment: string;
    landingPage: string;
    isPathshala: boolean;
    seenNewMyIssues: boolean;
    isScholar: boolean;

    constructor(data: any = {}) {
        this.batchUserSegment = data.batchUserSegment || "";
        this.landingPage = data?.landingPage || "";
        this.isPathshala = data?.isPathshala || false;
        this.seenNewMyIssues = data?.seenNewMyIssues || false;
        this.isScholar = data?.isScholar || false;
    }
}

export const planTableSelectedPlanAtom = atom<BatchPlan>(new BatchPlan({}));
const strUserModeAtom = atom(localStorage.getItem("userMode") ?? "");
export const userModeAtom = atom(
    (get) => {
        const data = get(strUserModeAtom);
        if (data.length <= 0) return new UserData({});
        const parsedData = JSON.parse(data);
        return new UserData(parsedData);
    },
    (get, set, newData: UserData) => {
        const dataString = JSON.stringify(newData);
        set(strUserModeAtom, dataString);
        localStorage.setItem("userMode", dataString);
    },
);

export const showVernacularModalAtom = atom<Boolean>(true);